// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'

$(document).ready(function () {

  function equalHeight(group) {
    //group.css('height','auto');
    var tallest = 0;
    group.each(function () {
      var thisHeight = $(this).height();
      if (thisHeight > tallest) {
        tallest = thisHeight;
      }
    });
    group.height(tallest);
  }

  equalHeight($(".eq-height .acf-label"));

  const headerHeight = $('.header').outerHeight();
  const footerHeight = $('.footer').outerHeight();
  const offsetFront = headerHeight + footerHeight;
  const frontBlock = $('.front-content');

  frontBlock.css({ height: `calc(100vh - ${offsetFront}px)` });

  const footerImgHeight = $('.footer__img img').outerHeight();
  const pageMain = $('.page-main, .calculator-overview-content').css({ paddingBottom: `${footerImgHeight}px` });

  const mobileNav = $('.menu-menu-1-container');
  mobileNav.css({
    height: `calc(100vh - ${headerHeight}px)`,
    marginTop: `${headerHeight}px`,
  });

  const navToggle = $('.header__hamburger');

  navToggle.on('click', (e) => {
    mobileNav.toggleClass('active');
    $(e.currentTarget).toggleClass('active');
    $('body').toggleClass('no-scroll', mobileNav.hasClass('active'));
  });

  document.addEventListener('wheel', (event) => {
    const activeElement = document.activeElement;

    if (
      activeElement &&
      activeElement.tagName === 'INPUT' &&
      activeElement.type === 'number' &&
      event.target === activeElement
    ) {
      event.preventDefault();
      activeElement.blur();

      window.scrollBy({
        top: event.deltaY,
        left: 0,
        behavior: 'auto',
      });
    }
  }, { passive: false });

});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js